{
  "name": "12edo (12-tone Equal Temperament)",
  "description": "12edo, a shorthand for \"equal divisions of an octave\", is the commonly used equal tempered scale. It divides an octave into 12 proportionally equal and equal sounding semitone intervals. It is notated here using HEJI (Helmholtz-Ellis JI Pitch Notation) accidentals, devised by Marc Sabat and Wolfgang von Schweinitz, 2000-2005, revised by Marc Sabat and Thomas Nicholson in 2020 with special thanks to M.O. Abbott, Catherine Lamb, and Wolfgang von Schweinitz. Fonts with embedded HEJI accidentals and unicode legends may be obtained by following the links at the bottom of this sidebar.",
  "scale": [
    "1\\12",
    "2\\12",
    "3\\12",
    "4\\12",
    "5\\12",
    "6\\12",
    "7\\12",
    "8\\12",
    "9\\12",
    "10\\12",
    "11\\12",
    "2/1"
  ],
  "key_colors_mode": "manual",
  "short_description": "12edo|12-tone-ET",
  "built_in_group": "12 Note Scales",
  "key_labels": "note_names",
  "note_names": [
    "C",
    "C D",
    "D",
    "D E",
    "E",
    "F",
    "F G",
    "G",
    "G A",
    "A",
    "A B",
    "B"
  ],
  "note_colors": [
    "#ffb2b2",
    "#c3c3d5",
    "#ededf7",
    "#c3c3d5",
    "#ededf7",
    "#ededf7",
    "#c3c3d5",
    "#ededf7",
    "#c3c3d5",
    "#ededf7",
    "#c3c3d5",
    "#ededf7"
  ],
  "equivSteps": 12,
  "fundamental": 440,
  "reference_degree": 9,
  "center_degree": 0,
  "rSteps": 2,
  "drSteps": 1,
  "hexSize": 42,
  "rotation": -16.102113751,
  "lumatone_anchor_note": 26,
  "lumatone_anchor_channel": 3
}
